import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { makeStripeConnectedAccountFormLink } from 'common/stripeHelpers';

import SrCard, { SR_CARD_FONT_SIZE_SMALL } from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLabel from 'client/components/SrLabel/SrLabel';
import SrStripeAccountInfo from 'client/components/SrStripeAccountInfo';

const SrPartnerBankAccountConnected = ({
  listingId,
  partnerId,
  stripeAccount,
  pendingStripeCharge,
}) => {
  const history = useHistory();

  const connectBankAccountUrl = makeStripeConnectedAccountFormLink({
    listingId,
    partnerId,
  });

  const onClickChangeBankAccount = () => {
    history.push(connectBankAccountUrl);
  };

  return (
    <>
      <SrCard headerSizeType={SR_CARD_FONT_SIZE_SMALL} header="Connected Bank">
        <SrBox height="21px" />
        <SrStripeAccountInfo stripeAccount={stripeAccount} />
        <SrBox maxWidth="400px">
          {pendingStripeCharge && (
            <SrBox margin="0 0 30px">
              <SrText color="orange300" weight="600">
                A transfer is in progress. You’re unable to change bank accounts until the transfer
                is completed.
              </SrText>
            </SrBox>
          )}
          <SrLabel
            alignCenter
            justifyCenter
            label={pendingStripeCharge ? 'Transfer in Progress' : 'Change Bank Account'}
            color="grey"
            borderColor="#7B8488"
            opacity={pendingStripeCharge ? '0.5' : '1'}
            onClick={pendingStripeCharge ? null : onClickChangeBankAccount}
          />
        </SrBox>
      </SrCard>
    </>
  );
};

SrPartnerBankAccountConnected.propTypes = {
  listingId: PropTypes.number,
  partnerId: PropTypes.number,
  stripeAccount: PropTypes.object.isRequired,
  pendingStripeCharge: PropTypes.bool,
};

SrPartnerBankAccountConnected.displayName = 'SrPartnerBankAccountConnected';

export default SrPartnerBankAccountConnected;
